import React from 'react';
import { motion } from 'framer-motion';
import { Moon, Sun } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';
export function ThemeToggle({
  className = ''
}: {
  className?: string;
}) {
  const {
    theme,
    toggleTheme
  } = useTheme();
  const isDark = theme === 'dark';
  return <button type="button" onClick={toggleTheme} aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'} title={isDark ? 'Switch to light mode' : 'Switch to dark mode'} className={`glass-flat relative grid h-9 w-9 place-items-center overflow-hidden rounded-xl text-muted-foreground transition-colors hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand ${className}`} data-id="element-473" data-mp="3m4ha9nrsv142">
      <motion.span key={theme} initial={{
      rotate: -90,
      opacity: 0,
      scale: 0.6
    }} animate={{
      rotate: 0,
      opacity: 1,
      scale: 1
    }} transition={{
      type: 'spring',
      stiffness: 320,
      damping: 22
    }} className="grid place-items-center" data-id="element-474" data-mp="33bddhtjac858">
        {isDark ? <Moon className="h-4 w-4" data-id="element-475" data-mp="1ga467c4dn65u" /> : <Sun className="h-4 w-4" data-id="element-476" data-mp="1c9bwkhrlez91" />}
      </motion.span>
    </button>;
}